[
  {
    "id": "SWW-M7-L203-001",
    "module": "SpellingWW",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "question": "Hij ... de bal hard. (schoppen)",
    "options": ["schopt", "schop", "schopte", "geschopt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "tt_hij",
    "familyId": "SWW-TT-HIJ-SCHOPPEN",
    "conceptId": "tt_hij_stam_plus_t",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'hij', dus stam + t. Stam van 'schoppen' is 'schop'. Schop + t = schopt.",
    "distractorExplanations": {
      "1": "Dit is de ik-vorm: ik schop. Bij 'hij' hoort schopt.",
      "2": "Dit is verleden tijd. De zin gaat over nu.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft': hij heeft geschopt."
    }
  },
  {
    "id": "SWW-M7-L203-002",
    "module": "SpellingWW",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "question": "De koekjes zijn ... (pakken).",
    "options": ["gepakt", "gepakd", "pakten", "pakt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_kofschip",
    "familyId": "SWW-VD-KOFSCHIP-PAKKEN",
    "conceptId": "vd_zwak_kofschip_t",
    "variantIndex": 1,
    "explanation": "Na 'zijn' gebruik je het voltooid deelwoord. Stam: pak. K zit in 't kofschip, dus eindigt op -t: gepakt.",
    "distractorExplanations": {
      "1": "K zit in 't kofschip, dus het is -t, niet -d.",
      "2": "Dit is verleden tijd meervoud. Na 'zijn' hoort een voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd. Na 'zijn' hoort een voltooid deelwoord."
    }
  },
  {
    "id": "SWW-M7-L203-003",
    "module": "SpellingWW",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "question": "Wij ... gisteren een spel. (spelen)",
    "options": ["speelden", "speelde", "spelen", "gespeeld"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_geen_kofschip",
    "familyId": "SWW-VT-ZWAK-SPELEN",
    "conceptId": "vt_zwak_meervoud",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' kies je verleden tijd. Onderwerp is 'wij' (meervoud). Dan wordt het: speelden.",
    "distractorExplanations": {
      "1": "Dit is enkelvoud (hij speelde). Hier is het meervoud: speelden.",
      "2": "Dit is tegenwoordige tijd. 'Gisteren' vraagt verleden tijd.",
      "3": "Dit is het voltooid deelwoord en hoort met 'hebben': wij hebben gespeeld."
    }
  },
  {
    "id": "SWW-M7-L203-004",
    "module": "SpellingWW",
    "difficulty": 203,
    "difficultyTier": 9,
    "levelCode": "M7",
    "group": 7,
    "question": "De wedstrijd is ... (eindigen).",
    "options": ["geëindigd", "geëindigt", "eindigde", "eindigt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_geen_kofschip",
    "familyId": "SWW-VD-EINDIGEN",
    "conceptId": "vd_zwak_geen_kofschip_d",
    "variantIndex": 1,
    "explanation": "Na 'is' gebruik je een voltooid deelwoord. Stam eindigt op g (niet in 't kofschip), dus -d: geëindigd.",
    "distractorExplanations": {
      "1": "G zit niet in 't kofschip, dus je schrijft -d, niet -t.",
      "2": "Dit is verleden tijd (eindigde), niet het voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd."
    }
  }
]
